import { Injectable } from '@angular/core';
import { TopLevelLayers } from '../menu/view-menu/top-level-layers';
import { NavaidModel } from '../models/navaid';
import { ToolsControlService } from './tools-control.service';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import VectorSource from 'ol/source/Vector';
import olMap from 'ol/Map';
import { MapService } from './map.service';
import GeoJSON from 'ol/format/GeoJSON';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';
import { CoordenateService } from './coordenate.service';
import * as olProj from 'ol/proj';

import MultiPoint from 'ol/geom/MultiPoint';
import { Feature} from 'ol';

import Circle from 'ol/geom/Circle';
import VectorLayer from 'ol/layer/Vector';
import { fromLonLat } from 'ol/proj';
import { Coordinate } from 'ol/coordinate';
import Polygon, { fromCircle } from 'ol/geom/Polygon';
import { VicentyToolControlService } from './vicenty-tool-control.service';
import Point from 'ol/geom/Point';

@Injectable({
  providedIn: 'root'
})
export class MultipathToolService {

  active : boolean;
  fullScreenMode : boolean = false;
  navaid: NavaidModel;
  vectorSource: VectorSource =  new VectorSource({

  });
  multipathElems:  MultipathToolElem[] = []
  map: olMap;
  colors: string[] = ['red', 'green','blue', 'purple'];
  colorIndex: number = 0;
  colorOfSelected = 'orange';
  selectedIndex:number;
  pointRadius :number= 2e3;
  constructor(
    private toolsService: ToolsControlService,
    private mapService: MapService,
    private vicentyTool: VicentyToolControlService,
    private rcsControl: CoordenateService
  ) {

    this.map = this.mapService.getMap('map');
    let appLayer = new VectorLayerDMTR({
      source: this.vectorSource,
    });

    appLayer.setVisible(true);
    this.map.addLayer(appLayer);
  }

  openFooter(navaid: NavaidModel):void {
    this.navaid = navaid;
    this.active = true;
    this.toolsService.navigationOnTop = true;
    for(var i = 0; i < this.multipathElems.length; i++)
      this.draw(i);
  }

  closeFooter(){
    this.active = false;
    this.multipathElems = [];
    this.selectedIndex = null;
    this.vectorSource.clear();
  }
  deleteElement(i:number){
    if(this.multipathElems[i].feature != null){
      this.vectorSource.removeFeature(this.multipathElems[i].feature);
      this.vectorSource.removeFeature(this.multipathElems[i].point);
    }

    this.multipathElems.splice(i,1);
  }
  deleteAll(){
    this.vectorSource.clear();
    this.multipathElems = [];
  }
  selectFeature(i: number){
    if(this.multipathElems[i].feature == null)
      return;
    this.setEllipseColorStyle(this.multipathElems[i].feature,this.colorOfSelected)
  }
  unSelectFeature(i: number){
    if(this.multipathElems[i].feature == null)
      return;
    this.setEllipseColorStyle(this.multipathElems[i].feature,this.multipathElems[i].color)
  }
  private calcDistFromFocus(majorRadius,minorRadius, theta, rotation){

		var e = Math.sqrt(1-Math.pow(minorRadius/majorRadius, 2));

		theta = VicentyToolControlService.degrees_to_radians(theta);
		rotation = VicentyToolControlService.degrees_to_radians(rotation);

		return (majorRadius*(1-Math.pow(e, 2))) / (1 + (e*Math.cos(theta - rotation)));
	}
  // this works for a static image (pixels) but the idea can be on any coordinate system
  private getEllipseFeature(center, semiMajor, semiMinor,azimute) {
    let coordinates = [] ;
    const radinas = Math.PI / 180 ;
    for (let angle = 0; angle < 360; angle++) {

      var point = VicentyToolControlService.calculateDestinationPoint(center[0],center[1],angle,
        this.calcDistFromFocus(semiMajor,semiMinor,angle,azimute));
    point = fromLonLat([point[1],point[0]],this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");

    coordinates.push(point);
    }
    var polygonFeatureT = new Feature(new Polygon([coordinates]));
      const geoJson = {
        'type': 'Feature',
        'geometry': {
          'type': 'Polygon',
          'coordinates': []
        }
      };
      return polygonFeatureT;
  }
  private setEllipseColorStyle(feature:Feature, color: string){
    const layerStyle = [  new Style({
      stroke: new Stroke({
        color: color,
        width: 1
      }),
    })];
    feature.setStyle(layerStyle);
  }
  private setPointColorStyle(pointFeature: Feature, color: string){
    const layerStyle = [  new Style({
      fill: new Fill({
        color: color,
      }),
      stroke: new Stroke({
        color: color,
      }),
    })];
    pointFeature.setStyle(layerStyle);
  }
  draw(i:number){
    var elem = this.multipathElems[i];
    if(elem.feature != null)
      this.vectorSource.removeFeature(elem.feature);
    const pathDelay = elem.delay * 300;
    const distance = VicentyToolControlService.calculateDistance(this.navaid.latitude,this.navaid.longitude,elem.latitude,elem.longitude);
    const azimute = VicentyToolControlService.calculateAzimuth(this.navaid.latitude,this.navaid.longitude,elem.latitude,elem.longitude);
    const minorRadius =  (Math.sqrt(Math.pow((distance + pathDelay), 2) - Math.pow(distance, 2)))/2;
    const majorRadius = (distance + pathDelay)/2


    let ellipseFeature = this.getEllipseFeature([this.navaid.latitude, this.navaid.longitude],majorRadius,minorRadius,azimute+ 180);

    if(elem.color == null){
      elem.color = this.colors[this.colorIndex%this.colors.length];
      this.colorIndex++;
    }
    this.setEllipseColorStyle(ellipseFeature,elem.color);
    elem.feature = ellipseFeature;
    this.vectorSource.addFeature(ellipseFeature);
    let geometryCircle: Circle = new Circle(fromLonLat([elem.longitude,elem.latitude], "EPSG:3857"),this.pointRadius);
     var point = new Feature(geometryCircle.transform("EPSG:3857",this.map.getView().getProjection().getCode()))
    this.setPointColorStyle(point,elem.color);
    this.vectorSource.addFeature(point);
    elem.point = point;
  }
  reproject(sourceProjection){
    this.vectorSource?.getFeatures().forEach(feature=>
        feature.getGeometry().transform(sourceProjection,this.map.getView().getProjection().getCode())
      );
  }
}


  export class MultipathToolElem{
    //legend: string = "";
    color: string;
    latitude: number = null;
    longitude: number = null;
    delay: number =null;
    feature: Feature;
    point: Feature;
}
